export { MultiLineEllipsisText } from './src/multi-line-ellipsis-text';
